// extracted by mini-css-extract-plugin
export var closeButton = "_em-2";
export var closeButtonIcon = "_em-3";
export var lightboxContent = "_em-1";
export var lightboxOverlay = "_em-0";